<style lang="scss">
    .zoezi-social-media{
        display:flex;
        a{display:block; text-decoration:none;}
        a:last-child{margin-right:0 !important;}
    }
</style>
<template>
    <div class="zoezi-social-media">
        <a v-for="(service, ix) in services" :key="ix" :href="service.url" :target="target" rel="nofollow" :style="iconStyle"><i class="mdi" :class="service.icon"></i><span class="d-sr-only">{{service.name}}</span></a>
        <div v-if="services.length==0 && this.$root.edit" class="d-flex">
            <i class="mdi mdi-share-variant-outline"></i>
            <div style="align-self: center; font-size:14px; margin-left: 10px;">{{$translate('Edit social icons')}}</div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'social-icons',
    zoezi: {
        title: 'Social icons',
        icon: 'mdi-share-variant-outline'
    },

    props: {
        iconsize: {
            title: 'Icon size (px)',
            type: Number,
            default: 32,
        },
        distance: {
            title: 'Icon spacing (px)',
            type: Number,
            default: 5,
        },
        color: {
            title: 'Color',
            type: String,
            fulltype: 'color',
            default: 'primary'
        },
        facebook: {
            title: 'Facebook (URL)',
            type: String,
            default: '',
        },
        instagram: {
            title: 'Instagram (URL)',
            type: String,
            default: '',
        },
        linkedin: {
            title: 'LinkedIn (URL)',
            type: String,
            default: '',
        },
        twitter: {
            title: 'Twitter (URL)',
            type: String,
            default: '',
        },
        mail: {
            title: 'E-mail',
            type: String,
            default: '',
        }
    },
    computed: {
        target: function(){
            return this.$root.edit ? '' : '_blank';
        },
        iconStyle: function(){
            return {'font-size' : this.iconsize + 'px', 'color' : this.$root.colorToHex(this.color), 'margin-right': this.distance + 'px'};
        },
        services: function(){
            let retval = [];
            if(this.facebook && this.facebook.startsWith('http'))
                retval.push({name: 'Facebook', icon: 'mdi-facebook', url: this.$root.edit ? 'javascript: void(0)' : this.facebook});
            if(this.instagram && this.instagram.startsWith('http'))
                retval.push({name: 'Instagram', icon: 'mdi-instagram', url: this.$root.edit ? 'javascript: void(0)' : this.instagram});
            if(this.linkedin && this.linkedin.startsWith('http'))
                retval.push({name: 'LinkedIn', icon: 'mdi-linkedin', url: this.$root.edit ? 'javascript: void(0)' : this.linkedin});
            if(this.twitter && this.twitter.startsWith('http'))
                retval.push({name: 'Twitter', icon: 'mdi-twitter', url: this.$root.edit ? 'javascript: void(0)' : this.twitter});
            if(this.mail && this.mail.indexOf('@')>0)
                retval.push({name: 'E-mail', icon: 'mdi-at', url: this.$root.edit ? 'javascript: void(0)' : 'mailto:' + this.mail});
            return retval;
        }
    },
}
</script>
